export const billingProfileHc = {
  datosFacturacion: {
    titulo: "Dati di fatturazione",
    requeridos: "I dati di fatturazione sono obbligatori",
  },
  perfil: {
    swalTitle: "Controlla la tua email",
    swalText:
      "Per continuare con la modifica della password, controlla la tua casella di posta e segui i passaggi",
    swalConfirm: "Continua",
    errorInesperado: "Ops! Si è verificato un errore imprevisto",
  },
  facturacionCuenta: {
    editarInfo: "Modifica informazioni",
    direccionLinea1: "Indirizzo riga 1",
    direccionLinea2: "Indirizzo riga 2 (facoltativo)",
    cancelar: "Annulla",
    guardando: "Salvataggio...",
    guardarCambios: "Salva modifiche",
    errorCargar: "Errore durante il caricamento dei dati di fatturazione",
    actualizadoOk: "Dati aggiornati correttamente",
    errorActualizar: `Errore durante l'aggiornamento`,
    errorActualizarDatos: `Errore durante l'aggiornamento dei dati`,
  },
};
